// Probably not ideal but this ensures we get the clean text content and not additional elements such as pills or badges included
export const getHeadingText = (element: HTMLElement): string => {
  const clone = element.cloneNode(true) as HTMLElement;
  clone.querySelectorAll('[data-tag-badge="true"]').forEach((badge) => badge.remove());
  return (clone.innerText || clone.textContent || '').trim().replace(/\s+/g, ' ');
};
